/** Whether the browser can show `src` as an image under `referrerPolicy`. The default matches `CoachAvatar`. */
export function imageLoads(
  src: string,
  referrerPolicy: ReferrerPolicy = 'no-referrer',
  timeoutMs = 10_000
): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image()
    const timer = window.setTimeout(() => finish(false), timeoutMs)
    function finish(loaded: boolean) {
      window.clearTimeout(timer)
      img.onload = null
      img.onerror = null
      resolve(loaded)
    }
    img.referrerPolicy = referrerPolicy
    img.onload = () => finish(true)
    img.onerror = () => finish(false)
    img.src = src
  })
}

/** `src` as a CSS `url()` value, escaped for a quoted CSS string. */
export function cssUrl(src: string): string {
  return `url("${src.replace(/[\\"\n\r\t]/g, (c) => `\\${c.charCodeAt(0).toString(16)} `)}")`
}
